import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {doc, getDoc} from 'firebase/firestore';
import Lottie from 'lottie-react';
import {db} from '../utils/firebase';
import {useLang} from '../context/LanguageContext';
import {DEFAULT_CODE_GEN_ENABLED} from '../utils/codeGen';
import vipAnimation from '../lotties/vip2.json';

const CodeGenerationCard = () => {
    const {t} = useLang();
    const navigate = useNavigate();
    const [enabled, setEnabled] = useState(null);

    useEffect(() => {
        const loadSettings = async () => {
            try {
                const snap = await getDoc(doc(db, 'appSettings', 'codeGeneration'));
                setEnabled(snap.exists() && typeof snap.data().enabled === 'boolean'
                    ? snap.data().enabled
                    : DEFAULT_CODE_GEN_ENABLED);
            } catch (err) {
                setEnabled(DEFAULT_CODE_GEN_ENABLED);
            }
        };
        loadSettings();
    }, []);

    // sectiunea este controlata din /apanel (appSettings/codeGeneration -> enabled)
    if (!enabled) {
        return null;
    }

    return (
        <div className="w-full max-w-[400px] mx-auto my-4">
            <button
                onClick={() => navigate('/code-ticket')}
                className="relative w-full flex items-center gap-3 bg-gradient-to-r from-[#1a1015] via-[#3a0d12] to-[#1a1015] border-2 border-red-600/70 text-white font-bold py-3 px-4 rounded-xl shadow-lg shadow-red-900/40 hover:border-red-400 hover:shadow-red-500/50 transition-all overflow-hidden"
            >
                <span className="absolute inset-0 bg-gradient-to-r from-transparent via-red-500/10 to-transparent pointer-events-none"/>

                <span className="absolute -top-2 right-4 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow animate-pulse">
                    NEW
                </span>

                <div className="shrink-0 -ml-1">
                    <Lottie animationData={vipAnimation} style={{width: 52, height: 52}}/>
                </div>

                <span className="text-left flex-1 leading-tight">
                    {t('txt.codeGenSectionTitle')}
                </span>
            </button>
        </div>
    );
};

export default CodeGenerationCard;
